export const MarketingConstants = {
  heading: 'Next-Generation Therapy EHR for a New Age in Skilled Nursing',
  panelQuestion: 'Why Settle for Outdated Systems?',
  panelText:
    "Rehab Connect isn't just another therapy EHR. It's a next-generation solution designed to drive efficiency, refine market strategy, and improve clinical outcomes. With modern, customizable features tailored for today's SNF therapy challenges, Rehab Connect bridges the gaps between technology, care, and compliance.",
  learnMore: 'Learn More',
};
